import registerApi from "../../../api/register/register";

const state = {
  mode: "",
  url: [],
  allowBack: false,
  time: 0,
  number: 0,
  status: "delete",
  noScroll: false
};

const getters = {};

const mutations = {
  change(state, { data }) {
    state.mode = data;
  },
  changeStatus(state, { data }) {
    state.status = data;
  },
  setUrl(state, { data }) {
    state.url = data;
  },
  cleartime(state) {
    state.time = 0;
  },
  addtime(state) {
    state.time = state.time + 1;
  },
  setNumber(state, { number }) {
    state.number = number;
  },
  scroll(state, { data }) {
    state.noScroll = data;
    console.log(data);
  }
};

const actions = {
  registerAccount({ state }, { params, callback }) {
    console.log(state);
    registerApi.createAccountApi({ params, callback }, res => {
      callback(res);
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/register/register.js